import React from "react";
import PropTypes from "prop-types";
import { useBodyScrollLock } from "../../utils/dom";
import Portal from "../common/Portal";
import FocusTrap from "../common/FocusTrap";
import IconClose from "../icons/IconClose";
import WistiaEmbed from "../WistiaEmbed";
import { Container, CloseIconLayout, VideoLayout } from "./styled/modal-video";

function ModalVideo({ wistiaId, onClose }) {
  useBodyScrollLock();
  return (
    <Portal>
      <FocusTrap>
        <Container onKeyUp={(e) => e.key === "Escape" && onClose()}>
          <CloseIconLayout onClick={onClose} aria-label="Close Video">
            <IconClose />
          </CloseIconLayout>
          <VideoLayout>
            <WistiaEmbed hashedId={wistiaId} />
          </VideoLayout>
        </Container>
      </FocusTrap>
    </Portal>
  );
}

ModalVideo.propTypes = {
  wistiaId: PropTypes.string.isRequired,
  onClose: PropTypes.func
};

export default ModalVideo;
